import React from 'react';
import BaseModal, { BaseModalProps } from '../base-modal/BaseModal';
import styles from './FullScreenModal.module.scss';

interface FullScreenModalProps extends BaseModalProps {
  innerContentClass?: string;
}

export default function FullScreenModal(props: FullScreenModalProps) {
  const { children, variant = 'custom', contentClassName, innerContentClass, ...rest } = props;

  return (
    <BaseModal
      variant={variant}
      contentClassName={`${styles.fullScreenContent} ${contentClassName}`}
      {...rest}
    >
      <div className={`${styles.fullScreenContentInner} ${innerContentClass}`}>{children}</div>
    </BaseModal>
  );
}
